// The HTML bootstrap establishes this base before any application assets load.
export const getAppBasePath = () => {
	const href = document.getElementById("builder-base")?.getAttribute("href") || "/";
	return href.replace(/\/$/, "");
};

// Use for browser-level URLs; React Router links already apply the basename.
export const getAppUrl = path => `${getAppBasePath()}${path}`;

export const getAppPathname = () => window.location.pathname.slice(getAppBasePath().length) || "/";
